import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';

var filterConstantsToSend = function filterConstantsToSend(selected, list) {
  return Object.fromEntries(selected.map(function (key) {
    return [key, list[key]];
  }));
};
var formatString = function formatString(title) {
  if ((title === null || title === void 0 ? void 0 : title.trim()) === '*') {
    return '';
  }
  return (title === null || title === void 0 ? void 0 : title.split(' ').join('-').toLowerCase().normalize('NFD').replace(/[\u0300-\u036F]/g, '').replace(/[^\dA-Za-z-]+/g, '')) || null;
};
var formatNumberToString = function formatNumberToString(value) {
  return Number.parseInt(value, 10).toString();
};
var getProgressPercentage = function getProgressPercentage(progress, duration) {
  var progressPercentage = progress * 100 / duration;
  return Math.round(progressPercentage);
};
var getChangeProgress = function getChangeProgress(progress, startProgress) {
  var _Math$round;
  var changeProgress = progress - startProgress;
  return (_Math$round = Math.round(changeProgress)) === null || _Math$round === void 0 ? void 0 : _Math$round.toString();
};
var removeUndefinedFromObject = function removeUndefinedFromObject(object) {
  var filteredObject = {};
  Object.keys(object).forEach(function (key) {
    if (object[key] !== undefined && object[key] !== null) {
      filteredObject[key] = object[key];
    }
  });
  return filteredObject;
};
var formatDataToSend = function formatDataToSend(_ref) {
  var userData = _ref.userData,
    assetData = _ref.assetData;
  try {
    var _content$episode, _content$episode$seas, _content$contentLocke, _content$channelId, _content$episode2, _content$episode2$epi, _content$episode3;
    var content = assetData.content,
      subtitleTrack = assetData.subtitleTrack,
      searchTerms = assetData.searchTerms,
      audioTrack = assetData.audioTrack,
      text = assetData.text,
      errorCode = assetData.errorCode,
      sectionName = assetData.sectionName,
      listPosition = assetData.listPosition,
      transmissionType = assetData.transmissionType,
      providerName = assetData.providerName,
      collectionName = assetData.collectionName,
      verticalScrollPercent = assetData.verticalScrollPercent,
      errorType = assetData.errorType,
      isKids = assetData.isKids,
      askSecurityCode = assetData.askSecurityCode,
      pageReferral = assetData.pageReferral,
      componentType = assetData.componentType,
      groupId = assetData.groupId,
      matchId = assetData.matchId,
      teamId = assetData.teamId,
      playOff = assetData.playOff,
      sectionId = assetData.sectionId,
      planId = assetData.planId,
      timestamp = assetData.timestamp,
      filterEpg = assetData.filterEpg,
      filterMiniEpg = assetData.filterMiniEpg,
      isSports = assetData.isSports,
      tab = assetData.tab,
      cancelMotive = assetData.cancelMotive,
      ratingServices = assetData.ratingServices,
      couponActivated = assetData.couponActivated,
      filterPdp = assetData.filterPdp,
      seriePosition = assetData.seriePosition,
      timeOnePage = assetData.timeOnePage,
      timeToStart = assetData.timeToStart,
      playerType = assetData.playerType,
      verticalPositionCarousel = assetData.verticalPositionCarousel,
      api = assetData.api;
    var formattedContent = {};
    var startProgressBarFormattedValue = formatNumberToString(content === null || content === void 0 ? void 0 : content.startProgressBar);
    var changeProgressCalc = getChangeProgress(content === null || content === void 0 ? void 0 : content.progress, content === null || content === void 0 ? void 0 : content.startProgressBar);
    var percentualCalculation = getProgressPercentage(content === null || content === void 0 ? void 0 : content.progress, content === null || content === void 0 ? void 0 : content.duration);
    formattedContent = {
      /* CUSTOM DIMENSIONS */
      v_content_name: formatString(content === null || content === void 0 ? void 0 : content.title),
      v_content_type: formatString(content === null || content === void 0 ? void 0 : content.type),
      v_content_id: content === null || content === void 0 ? void 0 : content.vrioAssetId,
      v_genre: formatString(content === null || content === void 0 ? void 0 : content.genre),
      v_play_source: formatString(content === null || content === void 0 ? void 0 : content.playSource),
      v_start_progress_bar: startProgressBarFormattedValue,
      v_channel_name: formatString(content === null || content === void 0 ? void 0 : content.channelName),
      v_serie_name: formatString(content === null || content === void 0 ? void 0 : content.serieName),
      v_season: content === null || content === void 0 ? void 0 : (_content$episode = content.episode) === null || _content$episode === void 0 ? void 0 : (_content$episode$seas = _content$episode.seasonNumber) === null || _content$episode$seas === void 0 ? void 0 : _content$episode$seas.toString(),
      v_search_terms: formatString(searchTerms),
      v_video_subtitle: subtitleTrack,
      v_video_language: audioTrack,
      v_text: formatString(text),
      v_error_code: formatString(errorCode),
      v_api: api === null || api === void 0 ? void 0 : api.toString(),
      v_section_name: formatString(sectionName),
      v_list_position: listPosition === null || listPosition === void 0 ? void 0 : listPosition.toString(),
      v_tab: formatString(tab),
      v_transmission_type: transmissionType,
      v_provider_name: formatString(providerName),
      v_collection_name: formatString(collectionName),
      v_content_locked: content === null || content === void 0 ? void 0 : (_content$contentLocke = content.contentLocked) === null || _content$contentLocke === void 0 ? void 0 : _content$contentLocke.toString(),
      v_error_type: formatString(errorType),
      v_is_kids: isKids === null || isKids === void 0 ? void 0 : isKids.toString(),
      v_ask_security_code: askSecurityCode === null || askSecurityCode === void 0 ? void 0 : askSecurityCode.toString(),
      v_page_referral: formatString(pageReferral),
      v_component_type: formatString(componentType),
      v_vertical_scroll_percent: verticalScrollPercent === null || verticalScrollPercent === void 0 ? void 0 : verticalScrollPercent.toString(),
      v_group_id: groupId === null || groupId === void 0 ? void 0 : groupId.toString(),
      v_match_id: matchId === null || matchId === void 0 ? void 0 : matchId.toString(),
      v_team_id: teamId === null || teamId === void 0 ? void 0 : teamId.toString(),
      v_playoff: formatString(playOff),
      v_section_id: sectionId === null || sectionId === void 0 ? void 0 : sectionId.toString(),
      v_plan_id: planId === null || planId === void 0 ? void 0 : planId.toString(),
      v_channel_id: content === null || content === void 0 ? void 0 : (_content$channelId = content.channelId) === null || _content$channelId === void 0 ? void 0 : _content$channelId.toString(),
      v_timestamp: timestamp === null || timestamp === void 0 ? void 0 : timestamp.toString(),
      v_episode_number: content === null || content === void 0 ? void 0 : (_content$episode2 = content.episode) === null || _content$episode2 === void 0 ? void 0 : (_content$episode2$epi = _content$episode2.episodeNumber) === null || _content$episode2$epi === void 0 ? void 0 : _content$episode2$epi.toString(),
      v_content_player_type: formatString(playerType),
      v_primary_genre: formatString(content === null || content === void 0 ? void 0 : content.primaryGenre),
      v_episode_name: formatString(content === null || content === void 0 ? void 0 : (_content$episode3 = content.episode) === null || _content$episode3 === void 0 ? void 0 : _content$episode3.episodeName),
      v_filter_epg: formatString(filterEpg),
      v_change_progress: changeProgressCalc,
      v_finish_progress_bar: changeProgressCalc,
      v_filter_miniepg: formatString(filterMiniEpg),
      v_is_sports: isSports === null || isSports === void 0 ? void 0 : isSports.toString(),
      v_cancel_motive: formatString(cancelMotive),
      v_rating_services: formatString(ratingServices),
      v_coupon_activated: formatString(couponActivated),
      v_filter_pdp: formatString(filterPdp),
      v_vertical_position_carousel: verticalPositionCarousel === null || verticalPositionCarousel === void 0 ? void 0 : verticalPositionCarousel.toString(),
      v_content_age_rating: formatString(content === null || content === void 0 ? void 0 : content.contentAgeRating),
      v_age_restricted_content: formatString(content === null || content === void 0 ? void 0 : content.ageRestrictedContent),
      v_change_parental_control: formatString(content === null || content === void 0 ? void 0 : content.changeParentalControl),
      /* CUSTOM METRICS */
      v_video_duration: content === null || content === void 0 ? void 0 : content.duration,
      v_finish_progress_percentual: percentualCalculation,
      v_serie_position: seriePosition,
      v_time_one_page: timeOnePage,
      v_start_video_percentual: percentualCalculation,
      v_change_progress_percentual: percentualCalculation,
      v_time_to_start: timeToStart
    };
    var formattedData = _objectSpread(_objectSpread({}, userData), formattedContent);
    return formattedData;
  } catch (error) {
    console.error("An error occurred generating content for GTM: ".concat(error.message));
    return null;
  }
};

export { filterConstantsToSend, formatDataToSend, formatNumberToString, formatString, getChangeProgress, getProgressPercentage, removeUndefinedFromObject };
//# sourceMappingURL=utils.js.map
